import {useNavigate} from "react-router-dom";

export const useGotoTitleSearch = ({title}) => {
    const navigate = useNavigate();
    const queryParams = new URLSearchParams({search: title.name, year: title.year, short: title.short, part: title.part})
    const goto = () => {
        navigate({pathname: "/", search: queryParams.toString()});
    }

    return goto;
}
